export default class DelimitadorDeCards {
  arrayChunks(array, chunks) {
    let final = [];
    let n = array.length;
    for (let i = 0; i < n; i += chunks) {
      final = [...final, array.slice(i, i + chunks)];
    }
    return final;
  }
}
